<template lang="pug">
page-template(title="Marcas Parceiras")
  grid-list.mt-4(col-width="200px")
    template(v-if="brands.length")
      brand-card(
        v-for="({ img, title, to }, i) in brands",
        :key="i",
        :img="img",
        :title="title",
        :to="to"
      )
</template>

<script>
import PageTemplate from "@/components/templates/Page.vue";
import BrandCard from "@/components/cards/Brand";

export default {
  computed: {
    brands() {
      return this.$rest("brands").list.map(({ id, img, title }) => ({
        img: img ? this.files + "/" + img : "",
        title,
        to: `/produtos?b=${id}`,
      }));
    },
  },
  beforeCreate() {
    this.$rest("brands").get();
  },
  components: {
    PageTemplate,
    BrandCard,
  },
};
</script>
